import React, { useState, useRef } from "react";
import {
  FormControl,
  Grid,
  TextField,
  Snackbar,
  Alert as MuiAlert,
  Button,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Box,
  CircularProgress,
  Backdrop,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Layout from "../../../layout/Layout";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { agentUser1API, config, statusAPI } from "../../../config";
import { useNavigate, useParams } from "react-router-dom";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Container } from "@mui/system";
import { useEffect } from "react";

const stateList = [
  { state_name: `Andhra Pradesh` },
  { state_name: `Andaman and Nicobar Islands` },
  { state_name: `Arunachal Pradesh` },
  { state_name: `Assam` },
  { state_name: `Bihar` },
  { state_name: `Chandigarh` },
  { state_name: `Chhattisgarh` },
  { state_name: `Dadar and Nagar Haveli` },
  { state_name: `Daman and Diu` },
  { state_name: `Delhi` },
  { state_name: `Lakshadweep` },
  { state_name: `Puducherry` },
  { state_name: `Goa` },
  { state_name: `Gujarat` },
  { state_name: `Haryana` },
  { state_name: `Himachal Pradesh` },
  { state_name: `Jammu and Kashmir` },
  { state_name: `Jharkhand` },
  { state_name: `Karnataka` },
  { state_name: `Kerala` },
  { state_name: `Madhya Pradesh` },
  { state_name: `Maharashtra` },
  { state_name: `Manipur` },
  { state_name: `Meghalaya` },
  { state_name: `Mizoram` },
  { state_name: `Nagaland` },
  { state_name: `Odisha` },
  { state_name: `Punjab` },
  { state_name: `Rajasthan` },
  { state_name: `Sikkim` },
  { state_name: `Tamil Nadu` },
  { state_name: `Telangana` },
  { state_name: `Tripura` },
  { state_name: `Uttar Pradesh` },
  { state_name: `Uttarakhand` },
  { state_name: `West Bengal` },
];

const roleOptions = [
  { id: "1", name: "Super Admin" },
  { id: "2", name: "IT Admin" },
  { id: "3", name: "User" },
];

function EditUser() {
  const navigate = useNavigate();
  const { userID } = useParams();

  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [locationGroupList, setlocationGroupList] = useState([]);
  const [txtDepartment, settxtDepartment] = useState("");
  const [intStatus, setStatus] = useState(1);
  const [txtState, settxtState] = useState("");
  const [txtLGroup, settxtLGroup] = useState("");
  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [txtBranch, settxtBranch] = React.useState("");
  const [txtRole, settxtRole] = React.useState("");
  const [isDeptHead, setIsDeptHead] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  let defaultValues = {};

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const options = stateList.map((option) => {
    const firstLetter = option.state_name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  let tempRef = useRef(false);
  useEffect(() => {
    if (tempRef.current === false) {
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "35",
      });

      config.method = "patch";
      config.url = statusAPI;
      config.data = data;

      axios(config)
        .then(function (response) {
          setDepartmentList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "80",
      });

      config.data = data;

      axios(config)
        .then(function (response) {
          setBranchList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "82",
      });

      config.data = data;

      axios(config)
        .then(function (response) {
          setlocationGroupList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  const validationSchema = Yup.object().shape({
    txtName: Yup.string().required("Name is required"),
    txtPhone: Yup.string().required("Phone is required"),
    txtEmail: Yup.string()
      .required("Email is required")
      .email("Please enter valid email format"),
    txtPassword: Yup.string().when("txtPassword", {
      is: (val) => val && val.length > 0,
      then: Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
    }),
    passwordConfirmation: Yup.string().oneOf(
      [Yup.ref("txtPassword"), null],
      "Passwords must match"
    ),
  }, [["txtPassword", "txtPassword"]]);

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  let filterUseRef = useRef(false);
  useEffect(() => {
    if (filterUseRef.current === false) {
      let data = JSON.stringify({
        intAgentID: parseInt(userID),
        intSPType: 7,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentUser1API;

      axios(config)
        .then(function (response) {
          const reqData = response.data.data[0];

          defaultValues.txtUserName = reqData.username;
          defaultValues.txtPhone = (!reqData.phone || reqData.phone === "undefined") ? "" : reqData.phone;
          defaultValues.txtEmail = reqData.email;
          defaultValues.txtName = reqData.name;
          defaultValues.txtEmpNo = reqData.emp_no;
          defaultValues.txtTitle = reqData.title;
          defaultValues.txtDepartment = reqData.department;
          defaultValues.txtBranch = reqData.branch;
          defaultValues.txtLocationGroup = reqData.location_group;
          defaultValues.txtState = reqData.state;
          defaultValues.intStatus = reqData.status;
          defaultValues.txtRole = reqData.role;

          setIsDeptHead(reqData.is_dept_head === 1);
          setStatus(reqData.status);
          settxtDepartment(parseInt(reqData.department));
          settxtLGroup(parseInt(reqData.location_group));
          settxtState(reqData.state);
          settxtBranch(parseInt(reqData.branch));
          settxtRole(reqData.role);

          reset({ ...defaultValues });
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      return () => {
        filterUseRef.current = true;
      };
    }
  }, []);

  function onSubmit(reqData) {
    setIsSubmitting(true);
    const data = JSON.stringify({
      txtUserName: reqData.txtName,
      txtPhone: reqData.txtPhone === null ? "" : reqData.txtPhone,
      txtEmail: reqData.txtEmail === null ? "" : reqData.txtEmail,
      txtPassword: reqData.txtPassword ? reqData.txtPassword : "",
      txtName: reqData.txtName === null ? "" : reqData.txtName,
      txtEmpNo: reqData.txtEmpNo === null ? "" : reqData.txtEmpNo,
      txtTitle: reqData.txtTitle === null ? "" : reqData.txtTitle,
      txtDepartment:
        reqData.txtDepartment === null ? "" : reqData.txtDepartment,
      txtBranch: reqData.txtBranch === null ? "" : reqData.txtBranch,
      txtLocationGroup:
        reqData.txtLocationGroup === null ? "" : reqData.txtLocationGroup,
      txtState: reqData.txtState === null ? "" : reqData.txtState,
      intAgentID: parseInt(userID),
      intStatus: intStatus,
      intRole: txtRole,
      intUserID: 0,
      intSPType: 6,
      intIsDeptHead: isDeptHead ? 1 : 0,
    });
    config.method = "PATCH";
    config.data = data;
    config.url = agentUser1API;

    axios(config)
      .then(function (response) {
        setOpen(true);
        setMessageType("success");
        if (response.data.message === "Email already exists") {
          setMessageType("warning");
          setMessage(response.data.message);
        } else if (response.data.message === "Emp No already exists") {
          setMessageType("warning");
          setMessage(response.data.message);
        } else {
          setMessage("User updated successfully");
          setTimeout(function () {
            navigate("/agent/user/list");
          }, 3000);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsSubmitting(false);
      })
      .finally(() => setIsSubmitting(false));
  }

  const handleSave = () => { };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitting}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <form onSubmit={handleSubmit(onSubmit)} className={`white-bg`}>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Title"
                  type="text"
                  label="Title"
                  {...register("txtTitle")}
                  focused
                />
                <Typography className="invalid-feedback">
                  {errors.txtTitle?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Name"
                  type="text"
                  label="Name"
                  {...register("txtName")}
                  focused
                />
                <Typography className="invalid-feedback">
                  {errors.txtName?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="EmpNo"
                  type="text"
                  label="EmpNo"
                  {...register("txtEmpNo")}
                  focused
                />
                <Typography className="invalid-feedback">
                  {errors.txtEmpNo?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Phone"
                  type="text"
                  label="Phone"
                  {...register("txtPhone")}
                  focused
                />
                <Typography className="invalid-feedback">
                  {errors.txtPhone?.message}
                </Typography>
              </FormControl>
            </Grid>

            {/* Department - Searchable Autocomplete */}
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                options={departmentList}
                getOptionLabel={(option) => option.name || ""}
                value={departmentList.find((r) => r.id === txtDepartment) || null}
                onChange={(event, newValue) => {
                  const val = newValue ? newValue.id : "";
                  settxtDepartment(val);
                  setValue("txtDepartment", val);
                }}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                renderInput={(params) => (
                  <TextField {...params} label="Department" variant="outlined" focused />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtDepartment?.message}
              </Typography>
            </Grid>

            {/* Branch - Searchable Autocomplete */}
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                options={branchList}
                getOptionLabel={(option) => option.name || ""}
                value={branchList.find((r) => r.id === txtBranch) || null}
                onChange={(event, newValue) => {
                  const val = newValue ? newValue.id : "";
                  settxtBranch(val);
                  setValue("txtBranch", val);
                }}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                renderInput={(params) => (
                  <TextField {...params} label="Branch" variant="outlined" focused />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtBranch?.message}
              </Typography>
            </Grid>

            {/* Location Group - Searchable Autocomplete */}
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                options={locationGroupList}
                getOptionLabel={(option) => option.name || ""}
                value={locationGroupList.find((r) => r.id === txtLGroup) || null}
                onChange={(event, newValue) => {
                  const val = newValue ? newValue.id : "";
                  settxtLGroup(val);
                  setValue("txtLocationGroup", val);
                }}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                renderInput={(params) => (
                  <TextField {...params} label="Location Group" variant="outlined" focused />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtLocationGroup?.message}
              </Typography>
            </Grid>

            {/* State - Searchable Autocomplete (unchanged) */}
            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <Autocomplete
                  id="combo-box-demo"
                  options={options}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.state_name}
                  inputValue={txtState}
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State"
                      variant="outlined"
                      focused
                      onChange={(e) => settxtState(e.target.value)}
                    />
                  )}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    if (newValue.state_name !== null) {
                      settxtState(newValue.state_name);
                      setValue("txtState", newValue.state_name);
                    }
                  }}
                />
                <Typography className="invalid-feedback">
                  {errors.txtState?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Email"
                  type="text"
                  label="Email"
                  {...register("txtEmail")}
                  focused
                />
                <Typography className="invalid-feedback">
                  {errors.txtEmail?.message}
                </Typography>
              </FormControl>
            </Grid>

            {/* Username field removed — name is used as username */}
            {/* <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Username"
                  type="text"
                  label="Username"
                  {...register("txtUserName")}
                  focused
                />
                <Typography className="invalid-feedback">
                  {errors.txtUserName?.message}
                </Typography>
              </FormControl>
            </Grid> */}

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="txtPassword"
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  {...register("txtPassword")}
                  focused
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography className="invalid-feedback">
                  {errors.txtPassword?.message}
                </Typography>
              </FormControl>
              <Typography sx={{ fontSize: "12px", color: "red", mt: 0.5 }}>
                 Leave password fields empty to keep the user's existing password. Enter a new password only if you want to reset it.
              </Typography>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="passwordConfirmation"
                  type={showConfirmPassword ? "text" : "password"}
                  label="Confirm Password"
                  {...register("passwordConfirmation")}
                  focused
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography className="invalid-feedback">
                  {errors.passwordConfirmation?.message}
                </Typography>
              </FormControl>
            </Grid>

            {/* Role - Searchable Autocomplete */}
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                options={roleOptions}
                getOptionLabel={(option) => option.name || ""}
                value={roleOptions.find((r) => r.id === String(txtRole)) || null}
                onChange={(event, newValue) => {
                  const val = newValue ? newValue.id : "";
                  settxtRole(val);
                  setValue("txtRole", val);
                }}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                renderInput={(params) => (
                  <TextField {...params} label="Role" variant="outlined" focused />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtRole?.message}
              </Typography>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-helper-label">
                  Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="Status"
                  value={intStatus}
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={12} md={12} textAlign="right">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Tooltip
                  title="Check this if the user is a department head"
                  arrow
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isDeptHead}
                        onChange={(e) => setIsDeptHead(e.target.checked)}
                      />
                    }
                    label="Department Head"
                  />
                </Tooltip>
                <Button
                  className={`btn-primary`}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </form>
    </Layout>
  );
}

export default EditUser;